// Port of api/fuel/app/classes/filter/package/games/rating/package/comment.php
import F from 'offline/filter/constants'
export default {
	run: function(pkg, local, global) {
		if (global.ownerType !== F.OWNER_USER) return pkg
		pkg.comment = (global.comments && global.comments[local.game_id]) || false
		return pkg
	}
}
